import { ADVISORS } from '../../data/advisors';

/** Tristan Midal (DAF) — id legacy du rôle support. */
const DAF_ROLE_ID = 'role-pierre-marchetti';

/**
 * 31/07/2026 — Cohérence narrative (retour user prod) : des emails signés
 * « Tristan Midal — DAF » partaient alors que Tristan n'était pas encore
 * recruté (ex. aléa « crédit véhicule du confrère » en début de partie).
 * Expéditeur des messages finance :
 *   1. Tristan Midal si le DAF est recruté ;
 *   2. sinon le conseiller choisi (Ouss Hervé / Dr Camille Orsini) ;
 *   3. sinon un expéditeur générique anonyme.
 */
export function getFinanceSender(state) {
  if ((state.hiredSupport || {})[DAF_ROLE_ID]) {
    return { senderName: 'Tristan Midal — DAF', signature: 'Tristan' };
  }
  const advisor = ADVISORS[state.selectedAdvisor];
  if (advisor) {
    return { senderName: `${advisor.name} — Conseiller`, signature: advisor.shortName || advisor.name };
  }
  return { senderName: 'Votre conseil financier', signature: 'Votre conseil financier' };
}
